/* RESPONSIBLE TEAM: team-ml */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

export class WorkforceSchedulingRulesRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(WorkforceSchedulingRulesRoute);
